import { TextNodeType } from "../../CommonLandingMweb.types";
import { Container, Icon, Title } from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

interface HeadingPersuasionProps {
  headingPersuasion?: {
    stats?: TextNodeType;
    icon?: string;
  };
}

export const HeadingPersuasion = ({
  headingPersuasion,
}: HeadingPersuasionProps) => {
  if (!headingPersuasion) return null;

  return (
    <Container>
      <Title>
        <FormattedText value={headingPersuasion.stats} />
      </Title>
      {headingPersuasion.icon ? (
        <Icon src={headingPersuasion.icon} alt="heading persuasion icon" />
      ) : null}
    </Container>
  );
};

